import {safelyParseJson, safelyStringifyJson} from "./utils";

export const getLocalStorageItem = (key: string) => safelyParseJson(localStorage.getItem(key) || '');

export const getSessionStorageItem = (key: string) => safelyParseJson(sessionStorage.getItem(key) || '');

export const setSessionStorageItem = (key: string, value: unknown) => sessionStorage.setItem(key, safelyStringifyJson(value));

export const updateSearchParam = ({prevSearchParams, paramsToDelete, paramsToSet}: {
    prevSearchParams: URLSearchParams;
    paramsToDelete?: string | string[];
    paramsToSet?: Record<string, string | number | boolean>;
}) => {
    const newSearchParams = new URLSearchParams(prevSearchParams);
    if (typeof paramsToDelete === 'string') {
        newSearchParams.delete(paramsToDelete);
    } else if (Array.isArray(paramsToDelete)) {
        for (const param of paramsToDelete) {
            newSearchParams.delete(param);
        }
    }

    for (const [key, val] of Object.entries(paramsToSet ?? [])) {
        newSearchParams.set(key, val.toString());
    }
    return newSearchParams;
}
